<template>
  <div class="container loanAudit" style="z-index:1">
    <div class="bankAuditDialog">
      <el-row>
        <el-col :span="24">
          <div class="bankAuditHeader">
            <div class="bankAuditHeaderName"></div>
            <div class="bankAuditHeaderClose" title="关闭" @click="closeContent">×</div>
          </div>
        </el-col>
      </el-row>
      <el-tabs v-model="activeName">
        <el-tab-pane label="审核信息" name="first">
          <el-scrollbar :height="scrollHeight" :noresize="true">
            <el-row>
              <el-col :span="24">
                <div class="bankAuditTitle">
                  <div class="bankAuditSplit"></div>
                  基本信息
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3" v-if="loanApply.PersonCompanyFlag==='company'">
                <div class="bankAuditLB">企业名称：</div>
              </el-col>
              <el-col :span="5" v-if="loanApply.PersonCompanyFlag==='company'">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanApply.PersonCompanyText"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="3" v-if="loanApply.PersonCompanyFlag==='person'">
                <div class="bankAuditLB">姓名：</div>
              </el-col>
              <el-col :span="5" v-if="loanApply.PersonCompanyFlag==='person'">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanApply.PersonCompanyText"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="bankAuditLB">联系方式：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanApply.Phone"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="bankAuditLB">区域：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <!-- <el-input
                      v-model="bankInfoObj.AreaName"
                      size="small"
                      placeholder="请输入区域">
                  </el-input> -->
                  <el-select disabled v-model="loanAudit.Area" size="small" placeholder="">
                    <el-option :label="area.AreaName" :value="area.AreaName" :key="area.AreaName" v-for="area in areaList"></el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="3">
                                    <div class="bankAuditLB">营业执照号/身份证号码：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanApply.PersonCompanyKey"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">主营业务：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.Business"
                                            size="small"
                                            style="width:250px;"
                                            :placeholder="secondBusinessPlaceHolder">
                                            123
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3">
                                    <div class="bankAuditLB">二级分类：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.ThirdBusiness"
                                            size="small"
                                            style="width:250px;"
                                            :placeholder="secondBusinessPlaceHolder">
                                        </el-input>
                                    </div>
                                </el-col>
                                <el-col :span="3" v-if="loanAudit.BusinessDetail">
                                    <div class="bankAuditLB">业务说明：</div>
                                </el-col>
                                <el-col :span="5" v-if="loanAudit.BusinessDetail">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.BusinessDetail"
                                            size="small"
                                            style="width:250px;"
                                            :placeholder="secondBusinessPlaceHolder">
                                        </el-input>
                                    </div>
                                </el-col>
            </el-row>
            <el-row>
              <el-col :span="3">
                <div class="bankAuditLB">客户类型：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-select disabled v-model="loanAudit.CustomType" placeholder="" size="small">
                    <el-option
                      v-for="item in khlx"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="bankAuditLB">客户性质：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-select disabled v-model="loanAudit.CustomProperty" placeholder="" size="small">
                    <el-option
                      v-for="item in khxz"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="bankAuditLB">项目类别：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-select disabled v-model="loanAudit.ProTypeName" placeholder="" size="small" @change="proTypeChange">
                    <el-option
                      v-for="item in proTypeList"
                      :key="item.ProTypeName"
                      :label="item.ProTypeName"
                      :value="item.ProTypeName">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3">
                <div class="bankAuditLB">项目风险比例(%)：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanAudit.RiskSharing"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="bankAuditLB">贷款金额(万元)：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanApply.Money"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <!-- <el-col :span="3">
                  <div class="bankAuditLB">贷款合同号：</div>
              </el-col>
              <el-col :span="5">
                  <div class="bankAuditContent">
                      <el-input
                          v-model="loanAudit.LoanCode"
                          size="small"
                          placeholder="请输入贷款合同号">
                      </el-input>
                  </div>
              </el-col> -->
              <el-col :span="3">
                <div class="bankAuditLB">贷款银行：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="bankInfoObj.BankSiteName"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <!-- <el-col :span="3">
                  <div class="bankAuditLB">还款状态：</div>
              </el-col>
              <el-col :span="5">
                  <div class="bankAuditContent">
                      <el-select v-model="loanAudit.ReturnMoneyStatus" placeholder="请选择" size="small">
                          <el-option
                          v-for="item in hkzt"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                          </el-option>
                      </el-select>
                  </div>
              </el-col> -->
              <el-col :span="3">
                <div class="bankAuditLB">担保期限(月)：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanAudit.LoanMonth"
                    size="small"
                    onkeyup="value=value.replace(/[^0-9]/g,'')"
                    placeholder=""
                    @change="onDbqxChange">
                  </el-input>
                </div>
              </el-col>
              <!-- <el-col :span="3">
                  <div class="bankAuditLB">出具担保函时间：</div>
              </el-col>
              <el-col :span="5">
                  <div class="bankAuditContent">
                      <el-date-picker
                          v-model="loanAudit.GuaranteeLetterTime"
                          size="small"
                          type="date"
                          placeholder="选择出具担保函时间">
                      </el-date-picker>
                  </div>
              </el-col> -->
              <el-col :span="3">
                <div class="bankAuditLB">到期时间：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-date-picker
                    disabled
                    v-model="loanAudit.LoanEndTime"
                    size="small"
                    type="date"
                    placeholder="">
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="bankAuditLB">贷款合同号：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanAudit.LoanCode"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="3">
                <div class="bankAuditLB">担保费率(%)：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanAudit.GuaranteeRate"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="bankAuditLB">担保费(元)：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanAudit.LoanMoney"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="bankAuditLB">借款利率：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanAudit.LoanRate"
                    oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="3">
                <div class="bankAuditLB">五级分类：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-select disabled v-model="loanAudit.Category" placeholder="请选择" size="small">
                    <el-option
                      v-for="item in wfl"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="bankAuditLB">主调：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanAudit.FristInquirer"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="bankAuditLB">副调：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanAudit.SecondInquirer"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <!-- <el-col :span="3">
                  <div class="bankAuditLB">委托担保合同号：</div>
              </el-col>
              <el-col :span="5">
                  <div class="bankAuditContent">
                      <el-input
                          v-model="loanAudit.EntrustedGuarantee"
                          size="small"
                          placeholder="请输入委托担保合同号">
                      </el-input>
                  </div>
              </el-col> -->

            </el-row>
            <el-row>
              <el-col :span="3">
                <div class="bankAuditLB">银行客户经理：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanAudit.AccountManager"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="bankAuditLB">银行客户经理联系方式：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanAudit.AccountManagerPhone"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="bankAuditTitle">
                  <div class="bankAuditSplit"></div>
                  经营情况
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3">
                <div class="bankAuditLB">资产总额（万元）：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanAudit.TotalAssets"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="3">
                                    <div class="bankAuditLB">资产负债率（%）：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.AssetCoverage"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
              <el-col :span="3">
                <div class="bankAuditLB">上年营业收入（万元）：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanAudit.LastYearIncomeAudit"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="bankAuditLB">上年利润（万元）：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanAudit.LastYearProfitAudit"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="bankAuditLB">上年税收（万元）：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanAudit.LastYearTaxAudit"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="bankAuditLB">从业人数：</div>
              </el-col>
              <el-col :span="5">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanAudit.PeopleCountAudit"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="bankAuditTitle" style="position: relative;">
                  <div class="bankAuditSplit"></div>
                  反担保方式
                  <div style="left: 0px;top: 0px;position: absolute;width: 100%;display: flex;justify-content: center;align-items: center;height: 40px">
                    <el-radio-group disabled v-model="loanAudit.GuaranteeType" style="margin:0px auto;" @change="loanTypeChange">
                      <el-radio :label="1">信用</el-radio>
                      <el-radio :label="2">保证</el-radio>
                      <el-radio :label="3">组合</el-radio>
                      <el-radio :label="4">抵押</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </el-col>
            </el-row>
            <template v-if="loanAudit.GuaranteeType===1">
              <el-row>
                <el-col :span="2">
                  <div class="bankAuditLB">暂无信息</div>
                </el-col>
              </el-row>
            </template>
            <template v-if="loanAudit.GuaranteeType===2">
              <template v-if="loanMortgage&&loanMortgage.length>0">
                <template v-for="(item,index) in loanMortgage" :key="item.Id">
                  <template v-if="item.Type === -1" >
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">保证人姓名：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.Guarantor"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">身份证号码：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.GuarantorID"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </template>
                </template>
              </template>
            </template>
            <template v-if="loanAudit.GuaranteeType===3">
              <template v-if="loanMortgage&&loanMortgage.length>0">
                <template  v-for="(item,index) in loanMortgage" :key="item.Id">
                  <template v-if="item.Type === -1" >
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">保证人姓名：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.Guarantor"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">身份证号码：</div>
                      </el-col>
                      <el-col :span="5">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.GuarantorID"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </template>
                  <template v-if="item.Type === 0" >
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">不动产：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.BdcName"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.BdcQzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">面积：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.BdcArea"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">价值(万元)：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.BdcMoney"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">抵押权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.BdcDyqzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </template>
                  <template v-else-if="item.Type === 1">
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">设备：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SbName"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">数量：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SbCount"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">型号：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SbType"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">价值(万元)：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SbMoney"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">抵押权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SbDyqzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </template>
                  <template v-else-if="item.Type === 2">
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">水域滩涂：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SytName"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SytQzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">面积：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SytArea"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">价值(万元)：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SytMoney"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">抵押权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SytDyqzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </template>
                  <template v-else-if="item.Type === 3">
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">农村承包土地：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.NccbtdName"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.NccbtdQzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">面积：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.NccbtdArea"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">价值(万元)：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.NccbtdMoney"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">抵押权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.NccbtdDyqzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </template>
                  <template v-else-if="item.Type === 4">
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">股权：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.GqName"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">数量：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.GqCount"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">价值(万元)：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.GqMoney"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">抵押权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.GqDyzqh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </template>
                  <template v-else-if="item.Type === 5">
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">其他：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.OtherBfwName"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">规格：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.OtherBfwGg"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">价值(万元)：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.OtherBfwMoney"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">抵押权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.OtherBfwDyqzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </template>
                </template>
              </template>
            </template>
            <template v-if="loanAudit.GuaranteeType===4">
              <template v-if="loanMortgage&&loanMortgage.length>0">
                <template  v-for="(item,index) in loanMortgage" :key="item.Id">
                  <template v-if="item.Type === 0" >
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">不动产：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.BdcName"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.BdcQzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">面积：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.BdcArea"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">价值(万元)：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.BdcMoney"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">抵押权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.BdcDyqzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </template>
                  <template v-else-if="item.Type === 1">
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">设备：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SbName"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">数量：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SbCount"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">型号：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SbType"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">价值(万元)：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SbMoney"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">抵押权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SbDyqzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </template>
                  <template v-else-if="item.Type === 2">
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">水域滩涂：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SytName"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SytQzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">面积：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SytArea"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">价值(万元)：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SytMoney"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">抵押权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.SytDyqzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </template>
                  <template v-else-if="item.Type === 3">
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">农村承包土地：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.NccbtdName"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.NccbtdQzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">面积：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.NccbtdArea"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">价值(万元)：</div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.NccbtdMoney"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">抵押权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.NccbtdDyqzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </template>
                  <template v-else-if="item.Type === 4">
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">股权：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.GqName"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">数量：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.GqCount"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">价值(万元)：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.GqMoney"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">抵押权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.GqDyzqh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </template>
                  <template v-else-if="item.Type === 5">
                    <el-row>
                      <el-col :span="2">
                        <div class="bankAuditLB">其他：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.OtherBfwName"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">规格：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.OtherBfwGg"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">价值(万元)：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.OtherBfwMoney"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                      <el-col :span="2">
                        <div class="bankAuditLB">抵押权证号：</div>
                      </el-col>
                      <el-col :span="3">
                        <div class="bankAuditContent">
                          <el-input
                            disabled
                            v-model="item.OtherBfwDyqzh"
                            size="small"
                            placeholder="">
                          </el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </template>
                </template>
              </template>
            </template>
            <template v-if="!loanMortgage||loanMortgage.length===0">
              <div style="line-height: 60px!important;text-align: center;">暂无信息</div>
            </template>
            <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        信用评分
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3">
                                        <div class="bankAuditLB">征信记录：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="loanAudit.xyzk_value1" placeholder="请选择" size="small" >
                                                <el-option
                                                v-for="item in xyzk_list1"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">征信查询:</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select  disabled v-model="loanAudit.xyzk_value2" placeholder="请选择" size="small" >
                                                <el-option
                                                v-for="item in xyzk_list2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">诉讼及执行情况：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent">  
                                            <el-select  disabled v-model="loanAudit.xyzk_value3" placeholder="请选择" size="small" >
                                                <el-option
                                                v-for="item in xyzk_list3"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">借款人稳定性：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select  disabled v-model="loanAudit.xyzk_value4" placeholder="请选择" size="small" >
                                                <el-option
                                                v-for="item in xyzk_list4"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">企业经营情况：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select  disabled v-model="loanAudit.xyzk_value5" placeholder="请选择" size="small" >
                                                <el-option
                                                v-for="item in xyzk_list5"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3">
                                        <div class="bankAuditLB">财务状况：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select  disabled v-model="loanAudit.hknl_value1" placeholder="请选择" size="small" >
                                                <el-option
                                                v-for="item in hknl_list1"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">收入及现金流:</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="loanAudit.hknl_value2" placeholder="请选择" size="small" >
                                                <el-option
                                                v-for="item in hknl_list2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">抵押物价值：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="loanAudit.hknl_value3" placeholder="请选择" size="small" >
                                                <el-option
                                                v-for="item in hknl_list3"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="3">
                                        <div class="bankAuditLB">担保人信用及能力：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="loanAudit.dbcs_value1" placeholder="请选择" size="small" >
                                                <el-option
                                                v-for="item in dbcs_list1"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">担保方式及风险:</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="loanAudit.dbcs_value2" placeholder="请选择" size="small" >
                                                <el-option
                                                v-for="item in dbcs_list2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="7"></el-col>
                                <el-col :span="10">
                                <div class="bankAuditInfoTable">
                                    <table class="bg-table" border="1" bordercolor="#4e717d">
                        <tr style="font-weight: bold;">
                        <td colspan="2">信用状况</td>
                        <td colspan="2">还款能力</td>
                        <td colspan="2">担保措施</td>
                        <td colspan="2">额外分：</td>
                        <td colspan="2">最终得分</td>
                        <td colspan="2">预授信(万元）</td>
                        </tr>
                        <tr style="font-weight: bold;">
                        <td colspan="2">{{ scorelist[0] }}</td>
                        <td colspan="2">{{ scorelist[1] }}</td>
                        <td colspan="2">{{ scorelist[2] }}</td>
                        <td colspan="2">{{ scorelist[3] }}</td>
                        <td colspan="2">{{ scorelist[4] }}</td>
                        <td colspan="2">{{ scorelist[5] }}</td>
                        </tr>
                      </table> 
                                </div>
                            </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        资产评价
                                    </div>
                                </el-col>
                            </el-row>
                             <el-row>
                                     <el-col :span="3">
                                        <div class="bankAuditLB">土地流转信息（亩）：</div>
                                    </el-col>
                                    <el-col :span="9">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanCreditArea.area"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                </el-row>
            <el-row>
              <el-col :span="24">
                <div class="bankAuditTitle">
                  <div class="bankAuditSplit"></div>
                  信用报告
                </div>
              </el-col>
            </el-row>
          <template v-if="zxbglist.length>0">
                                    <template v-for="(item,index) in zxbglist" :key="item.Id">
                                            <el-row>
                                                <el-col :span="2">
                                                    <div class="bankAuditLB">贷款银行：</div>
                                                </el-col>
                                                <el-col :span="3">
                                                    <div class="bankAuditContent"> 
                                                        <el-input disabled
                                                            v-model="item.name"
                                                            size="small"
                                                            placeholder="请输入贷款银行">
                                                        </el-input>
                                                    </div>
                                                </el-col>
                                                <el-col :span="2">
                                                    <div class="bankAuditLB">贷款余额（万元）：</div>
                                                </el-col>
                                                <el-col :span="2">
                                                    <div class="bankAuditContent"> 
                                                        <el-input disabled
                                                            v-model="item.money"
                                                            size="small"
                                                            placeholder="请输入贷款金额">
                                                        </el-input>
                                                    </div>
                                                </el-col>
                                                <el-col :span="2">
                                                    <div class="bankAuditLB">担保方式：</div>
                                                </el-col>
                                                <el-col :span="2">
                                                    <div class="bankAuditContent"> 
                                                        <el-select disabled v-model="item.bzfs" size="small" placeholder="请选择">
                                                          <el-option label="信用" value="1"></el-option>
                                                          <el-option label="保证" value="2"></el-option>
                                                          <el-option label="抵押" value="3"></el-option>
                                                          <el-option label="组合" value="4"></el-option>
                                                      </el-select>
                                                    </div>
                                                </el-col>
                                                <el-col :span="2">
                                                    <div class="bankAuditLB">是否逾期：</div>
                                                </el-col>
                                                <el-col :span="1">
                                                    <div class="bankAuditContent">
                                                        <el-select disabled v-model="item.islate" size="small" placeholder="请选择">
                                                          <el-option label="是" value="1"></el-option>
                                                          <el-option label="否" value="0"></el-option>
                                                      </el-select>
                                                    </div>
                                                </el-col>
                                                <el-col :span="2" v-if="item.islate=='1'">
                                                    <div class="bankAuditLB">逾期期限：</div>
                                                </el-col>
                                                <el-col :span="2" v-if="item.islate=='1'">
                                                    <div class="bankAuditContent"> 
                                                        <el-input disabled
                                                            v-model="item.month"
                                                            size="small"
                                                            placeholder="请输入贷款金额">
                                                        </el-input>
                                                    </div>
                                                </el-col>
                                                <el-col :span="1" v-if="item.islate=='1'">
                                                    <div class="bankAuditLB">金额：</div>
                                                </el-col>
                                                <el-col :span="2" v-if="item.islate=='1'">
                                                    <div class="bankAuditContent"> 
                                                        <el-input
                                                            disabled
                                                            v-model="item.lateMoney"
                                                            size="small"
                                                            placeholder="请输入逾期金额">
                                                        </el-input>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                    </template>
                                </template>
                         <template v-else>
                            <el-row>
                                <el-col :span="2">
                                    <div class="bankAuditLB">暂无信息</div>
                                </el-col>
                            </el-row>
                        </template>
                        <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        政务信息
                                    </div>
                                </el-col>
                            </el-row>
                             <el-row>
                                     <el-col :span="2">
                                        <div class="bankAuditLB">婚姻信息：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-input disabled
                                                v-model="loanCreditArea.HYXX"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB">户籍信息：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-input disabled
                                                v-model="loanCreditArea.HJXX"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB">社保信息：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-input disabled
                                                v-model="loanCreditArea.SBXX"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB">公积金信息：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-input disabled
                                                v-model="loanCreditArea.GJJXX"
                                                size="small"
                                                placeholder="">
                                            </el-input>
                                        </div>
                                    </el-col>
                                </el-row>
            <el-row>
              <el-col :span="24">
                <div class="bankAuditTitle">
                  <div class="bankAuditSplit"></div>
                  村镇干部评价
                </div>
              </el-col>
            </el-row>
            <el-row>
                                 <el-col :span="2">
                                        <div class="bankAuditLB" >积分制积分：</div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                               disabled
                                                v-model="loanCredit.comment2_jfzjf"
                                                size="small"
                                                placeholder="请输入积分制积分">
                                            </el-input>
                                        </div>
                                    </el-col>
                                <el-col :span="2">
                                    <div class="bankAuditLB" >规模：</div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanCredit.comment2_gm"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                 <el-col :span="2">
                                    <div class="bankAuditLB">技术：</div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanCredit.comment2_js"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                         <el-col :span="2">
                                    <div class="bankAuditLB" >效益：</div>
                                </el-col>
                                <el-col :span="10">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanCredit.comment2_xy"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                                 <el-col :span="2">
                                    <div class="bankAuditLB">综合信誉：</div>
                                </el-col>
                                <el-col :span="10">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanCredit.comment2"
                                            size="small"
                                            placeholder="">
                                        </el-input>
                                    </div>
                                </el-col>
                        </el-row>
            <el-row>
              <el-col :span="24">
                <div class="bankAuditTitle">
                  <div class="bankAuditSplit"></div>
                  同行评价
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="2">
                <div class="bankAuditLB" >规模：</div>
              </el-col>
              <el-col :span="10">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanCredit.comment_gm"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="2">
                <div class="bankAuditLB">技术：</div>
              </el-col>
              <el-col :span="10">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanCredit.comment_js"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="2">
                <div class="bankAuditLB" >效益：</div>
              </el-col>
              <el-col :span="10">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanCredit.comment_xy"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
              <el-col :span="2">
                <div class="bankAuditLB">综合信誉：</div>
              </el-col>
              <el-col :span="10">
                <div class="bankAuditContent">
                  <el-input
                    disabled
                    v-model="loanCredit.comment"
                    size="small"
                    placeholder="">
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="bankAuditTitle">
                  <div class="bankAuditSplit"></div>
                  合同号信息
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="2">
                                        <div class="bankAuditLB">委托担保合同号：</div>
                                    </el-col>
                                    <el-col :span="10">
                                        <div class="bankAuditContent"> 
                                           <el-form-item prop="WTDBHTH">
                                                <el-input
                                                    v-model="loanAudit.WTDBHTH"
                                                    size="small"
                                                    placeholder="请输入合同号">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="bankAuditLB">银行担保合同号：</div>
                                    </el-col>
                                    <el-col :span="10">
                                        <div class="bankAuditContent"> 
                                            <el-form-item prop="YHDBHTH" >
                                                <el-input 
                                                    v-model="loanAudit.YHDBHTH"
                                                    size="small"
                                                    placeholder="请输入合同号">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="bankAuditTitle">
                  <div class="bankAuditSplit"></div>
                  附件信息
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="bankAuditFileList" v-if="fileList_FJ.length>0">
                  <div v-for="(item,index) in fileList_FJ" :key="index">
                    <div class="bankAuditFileLink" :title="item.name">
                      <a :href="item.url" :download="item.name">{{item.name}}</a>
                    </div>
                  </div>
                </div>
                <div class="bankAuditFileList" v-else>
                  <div style="padding-left:50px;">无</div>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="bankAuditTitle">
                  <div class="bankAuditSplit"></div>
                  修改内容
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4">
                <div class="bankAuditLB" style="width:150px">补录修改内容：</div>
              </el-col>
              <el-col :span="20">
                <el-input
                  disabled
                  v-model="modifyFlowObj.ModifyContent"
                  size="small"
                  style="margin-top: 15px;"
                  placeholder="请输入补录修改内容">
                </el-input>
              </el-col>
            </el-row>
            <el-row v-if="modifyFlowObj.Status===2">
              <el-col :span="24">
                <div class="bankAuditTitle">
                  <div class="bankAuditSplit"></div>
                  拒绝理由
                </div>
              </el-col>
            </el-row>
            <el-row v-if="modifyFlowObj.Status===2">
              <el-col :span="4">
                <div class="bankAuditLB" style="width:150px">拒绝理由：</div>
              </el-col>
              <el-col :span="8">
                <el-input
                  disabled
                  v-model="modifyFlowObj.RefuseReason"
                  size="small"
                  style="margin-top: 15px;">
                </el-input>
              </el-col>
              <el-col :span="4">
                <div class="bankAuditLB" style="width:150px">拒绝时间：</div>
              </el-col>
              <el-col :span="8">
                <el-input
                  disabled
                  v-model="modifyFlowObj.UpdateTime"
                  size="small"
                  style="margin-top: 15px;">
                </el-input>
              </el-col>
            </el-row>
            <el-row v-if="modifyFlowObj.Status===3">
              <el-col :span="24">
                <div class="bankAuditTitle">
                  <div class="bankAuditSplit"></div>
                  通过信息
                </div>
              </el-col>
            </el-row>
            <el-row v-if="modifyFlowObj.Status===3">
              <el-col :span="4">
                <div class="bankAuditLB" style="width:150px">通过时间：</div>
              </el-col>
              <el-col :span="8">
                <el-input
                  disabled
                  v-model="modifyFlowObj.ThirdTime"
                  size="small"
                  style="margin-top: 15px;">
                </el-input>
              </el-col>
            </el-row>
            <el-row v-if="showType!=='view'">
              <el-col :span="24">
                <div class="bankAuditOperate">
                  <el-button size="small" type="success" @click="onPass">通过</el-button>
                  <el-button size="small" type="warning" @click="onRefuse">拒绝</el-button>
                  <el-button size="small" type="info" @click="onBack">退回</el-button>
                </div>
              </el-col>
            </el-row>
          </el-scrollbar>
        </el-tab-pane>
      </el-tabs>

    </div>
  </div>
</template>

<script>
    import {dateUtils} from "../../../utils/dateUtils";
    import apis from "../../../api";
    import flowapis from "../../../api/flow";
    import {utils} from "../../../utils/utils";
    import modifyFlowApi from "../../../api/modifyFlow";

    export default {
        name: "modifyFlowAudit",
        props: {
            modifyFlowId: {
                type: Number,
                require: true
            },
            showType: {
                type: String,
                require: true,
            },
            closeCallback: {
                type: Function,
                require: true
            },
            submitCallback: {
                type: Function,
                require: true
            }
        },
        mounted() {
            let that = this;
            that.calcTableHeight();
            // 注：window.onresize只能在项目内触发1次
            window.onresize = function windowResize () {
                that.calcTableHeight();
            }
            // 去获取信息
            this.queryData()
        },
        data() {
            return {
                modifyFlowObj:{
                },
                activeName:'first',
                activeNameZx:'first',
                scrollHeight:400,
                query: {
                    userName: "",
                },
                isVisible:this.visible,
                llListResult:[],
                llShow:false,
                cllShow:false,
                llquery:false,
                credit:{num:"暂无",comment:"暂无"},
                flowInfo:{},
                fileList:[],
                fileList_FJ:[],
                picList:[],
                reasonVisible:false,
                queryTime:dateUtils.dateToStr("yyyy-MM-dd hh:mm:00",new Date()),
                dialogImageUrl: '',
                dialogVisible: false,
                disabled: false,

                firstBusinessOption:['电商','种植','养殖','农产品加工','农资农机销售','农产品购销','农业服务','农业旅游农家乐','农业相关工程','其他'],
                secondBusinessTitle: '二级分类',
                secondBusinessPlaceHolder: '输入对应主营项目的二级类目',
                scorelist:[0,0,0,0,0,0],
                zxbglist:[],
                xyzk_list1:[{value:1,label:"无任何逾期"},
          {value:2, label:"轻微逾期，已结清"},
          {value:3, label:"多次逾期，无严重违约"},
          {value:4,label:"严重逾期或当前逾期"},
          {value:0,label:"无数据"},
        ],
        xyzk_list2:[{value:1,label:"近半年征信查询小于5次"},
          {value:2, label:"近半年征信贷款查询5-10次"},
          {value:3, label:"近半年征信贷款查询10次以上"},
          {value:0,label:"无数据"},
        ],
        xyzk_list3:[{value:1,label:"无诉讼记录"},
          {value:2, label:"已结案小额诉讼"},
          {value:3, label:"多未结案或大额诉讼"},
          {value:4,label:"频繁涉及诉讼"},
          {value:0,label:"无数据"},
        ],
        xyzk_list4:[{value:1,label:"已婚本地有房"},
          {value:2, label:"未婚本地有房"},
          {value:3, label:"已婚本地无房"},
          {value:4,label:"未婚本地无房"},
          {value:0,label:"无数据"},
        ],
        xyzk_list5:[{value:1,label:"经营稳定，盈利良好"},
          {value:2, label:"经营一般，盈利波动"},
          {value:3, label:"经营困难，当年亏损"},
          {value:4,label:"经营困难，连续亏损"},
          {value:0,label:"无数据"},
        ],
        hknl_list1:[{value:1,label:"资产负债率低"},
        {value:2, label:"资产负债率适中"},
        {value:3, label:"资产负债率偏高"},
        {value:4,label:"资产负债率过高"},
        {value:0,label:"无数据"},
        ],
        hknl_list2:[{value:1,label:"收入稳定，现金流充足"},
        {value:2, label:"收入一般，现金流尚可"},
        {value:3, label:"收入波动，现金流紧张"},
        {value:0,label:"无数据"},
        ],
        hknl_list3:[{value:1,label:"便于流通变现价值高于贷款金额"},
        {value:2, label:"便于流通变现价值低于贷款金额"},
        {value:3, label:"不便于流通变现"},
        {value:4, label:"无法办理正式抵押登记手续且不便于流通变现"},
        {value:5, label:"无法办理正式抵押登记手续且不便于流通变现"},
        {value:0,label:"无数据"},
        ],
        dbcs_list1:[{value:1,label:"信用优秀，担保能力强"},
        {value:2, label:"信用良好，担保能力适中"},
        {value:3, label:"信用一般，担保能力较弱"},
        {value:4,label:"信用较差，担保能力有限"},
        {value:5,label:"非有效担保人"},
        {value:0,label:"无数据"},
        ],
        dbcs_list2:[{value:1,label:"正式抵押+保证人"},
        {value:2, label:"正式抵押"},
        {value:3, label:"保证人"},
        {value:4, label:"无保证人或抵押物"},
        {value:0,label:"无数据"},
        ],
                loanApply:{
                    ApplyID:'',
                    UserId:'',
                    Phone:'',
                    PersonCompanyText:'',
                    PersonCompanyFlag:'',
                    PersonCompanyKey:'',
                    LoanTipsId:'',
                    Money:'',
                    CreateTime:'',
                    BankID:'',
                    BankSiteID:'',
                    SiteDirectorID:'',
                    FirstBusiness:'',
                    SecondBusiness:'',
                    PeopleCount:'',
                    LastYearIncome:'',
                    LastYearTax:'',
                    LastYearProfit:'',
                },
                loanAudit:{
                    Id:null,
                    Business:null,
                    BusinessDetail:null,
                    RiskSharing:null,
                    LoanCode:null,
                    LoanRate:null,
                    State:null,
                    LoanMonth:null,
                    FristInquirer:null,
                    SecondInquirer:null,
                    Category:null,
                    CreditRating:null,
                    TotalAssets:null,
                    SaleProceeds:null,
                    NetProfits:null,
                    Ratal:null,
                    LoanBalance:null,
                    GuaranteeType:3,
                    Guarantor:null,
                    GuarantorCode:null,
                    CustomProperty:null,
                    CustomType:null,
                    ReturnMoneyStatus:null,
                    GuaranteeLetterTime:null,
                    LoanEndTime:null,
                    LoanMoney:null,
                    EntrustedGuarantee:null,
                    AccountManager:null,
                    AccountManagerPhone:null,
                    ProTypeName:null,
                    Area:null,
                    GuaranteeRate:null,
                    PeopleCountAudit:'',
                    LastYearIncomeAudit:'',
                    LastYearTaxAudit:'',
                    LastYearProfitAudit:'',
                    WTDBHTH:'',
                    YHDBHTH:'',
                    xyzk_value5:null,
                xyzk_value4:null,
                xyzk_value3:null,
                xyzk_value2:null,
                xyzk_value1:null,
                hknl_value1:null,
                hknl_value2:null,
                dbcs_value1:null,
                dbcs_value2:1,
                hknl_value3:null
                },
                loanMortgage:[],
                loanCredit:{
                    Id:null,
                    keyword:null,
                    num:null,
                    createTime:null,
                    danwei:null,
                    money:null,
                    comment2:null,
                    comment2_gm:null,
                    comment2_xy:null,
                    comment2_js:null,
                    comment:null,
                    comment_xy:null,
                    comment_gm:null,
                    comment_js:null
                },
                loanCreditArea:{
                    Id:null,
                    keyword:null,
                    name:null,
                    area:null,
                },
                khlx:[
                    {
                        value:"家庭农场",
                        label:"家庭农场"
                    },
                    {
                        value:"合作社",
                        label:"合作社"
                    },
                    {
                        value:"公司",
                        label:"公司"
                    },
                    {
                        value:"种养大户",
                        label:"种养大户"
                    },
                    {
                        value:"个体户",
                        label:"个体户"
                    }
                ],
                wjfx:[
                    {
                        value:"正常贷款",
                        label:"正常贷款"
                    },
                    {
                        value:"关注贷款",
                        label:"关注贷款"
                    },
                    {
                        value:"次级贷款",
                        label:"次级贷款"
                    },
                    {
                        value:"可疑贷款",
                        label:"可疑贷款"
                    },
                    {
                        value:"损失贷款",
                        label:"损失贷款"
                    }
                ],
                khxz:[
                    {
                        value:"新增",
                        label:"新增"
                    },
                    {
                        value:"续贷",
                        label:"续贷"
                    },
                    {
                        value:"展期",
                        label:"展期"
                    }
                ],
                hkzt:[
                    {
                        value:1,
                        label:"结清"
                    },
                    {
                        value:2,
                        label:"逾期"
                    },
                    {
                        value:3,
                        label:"代偿"
                    }
                ],
                dialogVisible2:false,
                dyType:'',
                dyTypes:[],
                dyTypes2:[
                    {
                        value:-1,
                        label:"保证人"
                    }
                ],
                dyTypes3:[
                    {
                        value:-1,
                        label:"保证人"
                    },
                    {
                        value:0,
                        label:"不动产"
                    },
                    {
                        value:1,
                        label:"设备"
                    },
                    {
                        value:2,
                        label:"水域滩涂"
                    },
                    {
                        value:3,
                        label:"农村承包土地"
                    },
                    {
                        value:4,
                        label:"股权"
                    },
                    {
                        value:5,
                        label:"其他"
                    }
                ],
                dyTypes4:[
                    {
                        value:0,
                        label:"不动产"
                    },
                    {
                        value:1,
                        label:"设备"
                    },
                    {
                        value:2,
                        label:"水域滩涂"
                    },
                    {
                        value:3,
                        label:"农村承包土地"
                    },
                    {
                        value:4,
                        label:"股权"
                    },
                    {
                        value:5,
                        label:"其他"
                    }
                ],
                proTypeList:[],
                bankInfoObj:{},
                areaList:[],
                myInterval:null,
                rules_loanAudit: {
                    Area:[
                        { required: true, message: '请选择区域', trigger: 'change' }
                    ],
                    CustomType:[
                        { required: true, message: '请选择客户类型', trigger: 'change' }
                    ],
                    CustomProperty:[
                        { required: true, message: '请选择客户性质', trigger: 'change' }
                    ],
                    ProTypeName:[
                        { required: true, message: '请选择项目类别', trigger: 'change' }
                    ],
                    RiskSharing:[
                        { required: true, message: '请填写项目风险比例(%)', trigger: 'change' }
                    ],
                    LoanMonth:[
                        { required: true, message: '请填写担保期限(月)', trigger: 'change' }
                    ],
                    LoanEndTime:[
                        { required: true, message: '请选择到期时间', trigger: 'change' }
                    ],
                    LoanCode:[
                        { required: true, message: '请填写贷款合同号', trigger: 'change' }
                    ],
                    GuaranteeRate:[
                        { required: true, message: '请填写担保费率(%)', trigger: 'change' }
                    ],
                    LoanMoney:[
                        { required: true, message: '请填写担保费(元)', trigger: 'change' }
                    ],
                    LoanRate:[
                        { required: true, message: '请填写借款利率', trigger: 'change' }
                    ],
                    Category:[
                        { required: true, message: '请选择五级分类', trigger: 'change' }
                    ],
                    FristInquirer:[
                        { required: true, message: '请填写主调', trigger: 'change' }
                    ],
                    SecondInquirer:[
                        { required: true, message: '请填写副调', trigger: 'change' }
                    ],
                    WTDBHTH:[
                        { required: true, message: '请填写合同号', trigger: 'change' }
                    ],
                    YHDBHTH:[
                        { required: true, message: '请填写合同号', trigger: 'change' }
                    ],
                },
                rules_loanApply:{
                    Money:[
                        { required: true, message: '请填写贷款金额(万元)', trigger: 'change' }
                    ],

                }
            }
        },
        methods: {
            onPass() {
                let that = this
                this.$confirm("确定通过审核？", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let param={
                        id:that.modifyFlowId,
                        auditType: that.showType
                    }
                    modifyFlowApi.passModifyFlow(param).then(res=>{
                        if(res){
                            that.submitCallback.call()
                        }else {
                            that.$message.error("提交失败")
                        }
                    })
                }).catch(()=>{})
            },
            onRefuse() {
                let that = this
                this.$prompt('请输入拒绝理由', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputType: 'text',
                    inputPattern: /^.+$/,
                    inputErrorMessage: '必须输入拒绝理由',
                }).then(({ value }) => {
                     let param = {
                         reason: value,
                         id:that.modifyFlowId,
                         auditType: that.showType
                     }
                     modifyFlowApi.refuseModifyFlow(param).then(res=>{
                         if(res){
                             that.submitCallback.call()
                         }else {
                             that.$message.error("提交失败")
                         }
                     })
                }).catch(()=>{})
            },
            onBack(){
              let that = this
                this.$prompt('请输入退回理由', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputType: 'text',
                    inputPattern: /^.+$/,
                    inputErrorMessage: '必须输入退回理由',
                }).then(({ value }) => {
                     let param = {
                         reason: value,
                         id:that.modifyFlowId,
                         auditType: that.showType,
                         CurrentNode: that.modifyFlowObj.CurrentNode
                     }
                     modifyFlowApi.backModifyFlow(param).then(res=>{
                         if(res){
                             that.submitCallback.call()
                         }else {
                             that.$message.error("提交失败")
                         }
                     })
                }).catch(()=>{})
            },
            setObjEmptyToNull(obj){
                Object.keys(obj).forEach(function(key, index) {
                    if (this[key] === '') this[key] = null;
                }, obj);
                return obj
            },
            queryData(){
                let that = this
                this.scorelist=[0,0,0,0,0,0]
                this.zxbglist=[]
                // 查询审核信息
                modifyFlowApi.getModifyFlowAllInfo({id:that.modifyFlowId}).then(res=>{
                    this.modifyFlowObj = res.modifyFlowObj
                    let fileList = res.fileList
                    if(fileList&&fileList.length>0){
                        that.fileList_FJ = []
                        for(let f=0;f<fileList.length;f++){
                            that.fileList_FJ.push({
                                name:fileList[f]['Name'],
                                url:fileList[f]['Url']
                            })
                        }
                    }else{
                        that.fileList_FJ = []
                    }
                    let infoObj = res.infoObj
                    if(infoObj){
                        if(infoObj.applyObj){
                            that.loanApply = infoObj.applyObj
                            that.changeSecondBusinessShow(that.loanApply.FirstBusiness)
                        }else{
                            that.setEmptyApply()
                            that.changeSecondBusinessShow(that.loanApply.FirstBusiness)
                        }
                        if(infoObj.areaList){
                            that.areaList = infoObj.areaList
                        }else{
                            that.setEmptyApply()
                        }

                        if(infoObj.auditObj){
                            that.loanAudit = infoObj.auditObj
                            if(that.loanAudit.GuaranteeLetterTime){
                                that.loanAudit.GuaranteeLetterTime = new Date(that.loanAudit.GuaranteeLetterTime)
                            }
                            if(that.loanAudit.LoanEndTime){
                                that.loanAudit.LoanEndTime= new Date(that.loanAudit.LoanEndTime)
                            }
                            if(that.loanAudit.scoreList){
                              that.scorelist = that.loanAudit.scoreList.split(",")
                              }
                              if(that.loanAudit.zxbgList){
                                that.zxbglist = JSON.parse(that.loanAudit.zxbgList)
                              }
                              if(that.loanAudit.ThirdBusiness){
                                  that.loanAudit.ThirdBusiness=that.loanAudit.ThirdBusiness.toString().split(",");
                                }else{
                                   that.loanAudit.BusinessDetail=that.loanApply.SecondBusiness
                                         that.loanAudit.Business=that.loanApply.FirstBusiness
                                 that.loanAudit.ThirdBusiness=that.loanApply.ThirdBusiness==null?[]:that.loanApply.ThirdBusiness.toString().split(",");
                               }
                        }else{
                            that.setEmptyAudit()
                            that.loanAudit.LastYearIncomeAudit = that.loanApply.LastYearIncome;
                            that.loanAudit.LastYearProfitAudit = that.loanApply.LastYearProfit;
                            that.loanAudit.LastYearTaxAudit = that.loanApply.LastYearTax;
                            that.loanAudit.PeopleCountAudit = that.loanApply.PeopleCount;
                            that.loanAudit.BusinessDetail=that.loanApply.SecondBusiness
                           that.loanAudit.Business=that.loanApply.FirstBusiness
                         that.loanAudit.ThirdBusiness=that.loanApply.ThirdBusiness==null?[]:that.loanApply.ThirdBusiness.toString().split(",");
                        }

                        if(infoObj.mortgageObj){
                            that.loanMortgage = infoObj.mortgageObj
                        }else{
                            that.loanMortgage = []
                        }

                        if(infoObj.proTypeList){
                            that.proTypeList = infoObj.proTypeList
                            if(that.loanAudit.GuaranteeRate){
                                that.setDbInfo()
                            }else{
                                that.setDbInfo2()
                            }
                        }else{
                            that.proTypeList = []
                        }
                        if(infoObj.bankInfoObj){
                            that.bankInfoObj = infoObj.bankInfoObj
                        }else{
                            that.bankInfoObj = {}
                        }
                        if(infoObj.loanCreditObj){
                            that.loanCredit = infoObj.loanCreditObj
                        }else{
                            that.setEmptyCredit()
                        }

                        if(infoObj.loanCreditAreaObj){
                            that.loanCreditArea = infoObj.loanCreditAreaObj
                        }else{
                            that.setEmptyCreditArea()
                        }
                    }else{
                        that.setEmptyApply()
                        that.setEmptyAudit()
                        that.loanMortgage = []
                        that.setEmptyCredit()
                        that.setEmptyCreditArea()
                    }
                })

            },
            onDbqxChange(){
                let that = this
                let now = new Date()
                let givenMonth = now.getMonth()
                let newMonth = givenMonth + parseInt(that.loanAudit.LoanMonth)
                now.setMonth(newMonth)
                that.loanAudit.LoanEndTime = now
                that.setDbInfo()
            },
            setDbInfo(){
                let that = this
                try{
                    that.loanAudit.LoanMoney = Math.floor((((that.loanApply.Money*10000)*((that.loanAudit.GuaranteeRate*1.0)/100.0)*parseInt(that.loanAudit.LoanMonth))/12) * 100) / 100
                    if(isNaN(that.loanAudit.LoanMoney)){
                        that.loanAudit.LoanMoney = ''
                    }
                }catch(e){
                    that.loanAudit.GuaranteeRate = ''
                    that.loanAudit.RiskSharing = null
                    that.loanAudit.LoanMoney = null
                }

            },
            setDbInfo2(){
                let that = this
                for(let i=0;i<that.proTypeList.length;i++){
                    if(that.proTypeList[i]["ProTypeName"]===that.loanAudit.ProTypeName){
                        that.loanAudit.GuaranteeRate = that.proTypeList[i]['GuaranteeRate']
                        that.loanAudit.RiskSharing = that.proTypeList[i]['RiskRate']
                        try{
                            that.loanAudit.LoanMoney = Math.floor((((that.loanApply.Money*10000)*((that.loanAudit.GuaranteeRate*1.0)/100.0)*parseInt(that.loanAudit.LoanMonth))/12) * 100) / 100
                            if(isNaN(that.loanAudit.LoanMoney)){
                                that.loanAudit.LoanMoney = ''
                            }
                        }catch(e){
                            that.loanAudit.GuaranteeRate = ''
                            that.loanAudit.RiskSharing = null
                            that.loanAudit.LoanMoney = null
                        }
                        break
                    }
                }
            },
            showInput(){
                switch(this.loanAudit.GuaranteeType){
                    case 2:
                        this.dyTypes = this.dyTypes2
                        break;
                    case 3:
                        this.dyTypes = this.dyTypes3
                        break;
                    case 4:
                        this.dyTypes = this.dyTypes4
                        break;
                }
                this.dialogVisible2 = true
            },
            handleClose(){
                this.dialogVisible2 = false
            },
            onAddItemChange(){
                let item= this.getEmptyMortgage()
                item.Type = this.dyType
                this.loanMortgage.push(item)
                this.dialogVisible2 = false
            },
            setEmptyApply(){
                let that = this
                that.loanApply = {
                    ApplyID:'',
                    UserId:'',
                    Phone:'',
                    PersonCompanyText:'',
                    PersonCompanyFlag:'',
                    PersonCompanyKey:'',
                    LoanTipsId:'',
                    Money:'',
                    CreateTime:'',
                    BankID:'',
                    BankSiteID:'',
                    SiteDirectorID:'',
                    FirstBusiness:'',
                    SecondBusiness:'',
                    PeopleCount:'',
                    LastYearIncome:'',
                    LastYearTax:'',
                    LastYearProfit:'',
                }
            },
            setEmptyAudit(){
                let that = this
                that.loanAudit = {
                    Id:null,
                    Business:null,
                    BusinessDetail:null,
                    RiskSharing:null,
                    LoanCode:null,
                    LoanRate:null,
                    State:null,
                    LoanMonth:null,
                    FristInquirer:null,
                    SecondInquirer:null,
                    Category:null,
                    CreditRating:null,
                    TotalAssets:null,
                    SaleProceeds:null,
                    NetProfits:null,
                    Ratal:null,
                    LoanBalance:null,
                    GuaranteeType:3,
                    Guarantor:null,
                    GuarantorCode:null,
                    CustomProperty:null,
                    CustomType:null,
                    ReturnMoneyStatus:null,
                    GuaranteeLetterTime:null,
                    LoanEndTime:null,
                    LoanMoney:null,
                    EntrustedGuarantee:null,
                    AccountManager:null,
                    AccountManagerPhone:null,
                    ProTypeName:null,
                    Area:null,
                    GuaranteeRate:null,
                    WTDBHTH:null,
                    YHDBHTH:null,
                    xyzk_value5:null,
                xyzk_value4:null,
                xyzk_value3:null,
                xyzk_value2:null,
                xyzk_value1:null,
                hknl_value1:null,
                hknl_value2:null,
                dbcs_value1:null,
                dbcs_value2:1,
                hknl_value3:null
                }
            },
            getEmptyMortgage(){
                let loanMortgagetemp = {
                    Id:null,
                    AuditID:null,
                    Guarantor:null,
                    GuarantorID:null,
                    BdcName:null,
                    BdcQzh:null,
                    BdcArea:null,
                    BdcMoney:null,
                    BdcDyqzh:null,
                    SbName:null,
                    SbCount:null,
                    SbType:null,
                    SbMoney:null,
                    SbDyqzh:null,
                    SytName:null,
                    SytQzh:null,
                    SytArea:null,
                    SytMoney:null,
                    SytDyqzh:null,
                    NccbtdName:null,
                    NccbtdQzh:null,
                    NccbtdArea:null,
                    NccbtdMoney:null,
                    NccbtdDyqzh:null,
                    GqName:null,
                    GqCount:null,
                    GqMoney:null,
                    GqDyzqh:null,
                    OtherName:null,
                    OtherCount:null,
                    OtherGg:null,
                    OtherMoney:null,
                    OtherDyqzh:null,
                    OtherBfwName:null,
                    OtherBfwGg:null,
                    OtherBfwMoney:null,
                    OtherBfwDyqzh:null,
                    Type:null
                }
                return loanMortgagetemp
            },
            setEmptyCredit(){
                let that = this
                that.loanCredit = {
                    Id:null,
                    keyword:null,
                    num:null,
                    createTime:null,
                    danwei:null,
                    money:null,
                    comment2:null,
                    comment2_gm:null,
                    comment2_xy:null,
                    comment2_js:null,
                    comment:null,
                    comment_xy:null,
                    comment_gm:null,
                    comment_js:null
                }
            },
            setEmptyCreditArea(){
                let that = this
                that.loanCreditArea = {
                    Id:null,
                    keyword:null,
                    name:null,
                    area:null,
                }
            },
            onRemoveTypeChange(index){
                this.loanMortgage.splice(index, 1)
            },
            loanTypeChange(){
            },
            proTypeChange(){
                let that = this
                that.setDbInfo2()
            },
            onDBFLChange(){
                let that = this
                that.setDbInfo()
            },
            beforeAvatarFileUpload(file) {
                let that = this
                const isLt2M = file.size/1024/1024 <10
                if(!isLt2M){
                    that.$message.error("上传文件大小不能超过10MB")
                }
                return true
            },
            uploadFileFile_FJ(item){
                let that = this
                let fileObj = item.file
                const form = new FormData()
                form.append("file",fileObj)
                apis.uploadFile(form).then(res => {
                    that.fileList_FJ.push({
                        name: that.getFileName(res.fullPath),
                        url:res.fullPath
                    })
                    // let fileInfo = {
                    //     ProcessId:that.flowInfo.Id,
                    //     Type:'2',
                    //     Url:res.fullPath,
                    //     Name:that.getFileName(res.fullPath),
                    //     UploadType:2
                    // }
                    // flowapis.addLoanFile({fileList:[fileInfo]}).then(res => {})
                });
            },
            getFileName(path){
                var pos1 = path.lastIndexOf('/');
                var pos2 = path.lastIndexOf('\\');
                var pos  = Math.max(pos1, pos2)
                if( pos<0 )
                    return path;
                else
                    return path.substring(pos+1);
            },
            handleFileRemove_FJ(file) {
                let that = this
                if(file){
                    for(let i=0;i<that.fileList_FJ.length;i++){
                        if(file.url===that.fileList_FJ[i].url){
                            that.fileList_FJ.splice(i,1)
                        }
                    }
                }
            },
            onFirstBusinessChooseConfirm(value){
                //变更二级分类的标题和placeholder
                this.changeSecondBusinessShow(value)
            },
            changeSecondBusinessShow(value) {
                switch (value) {
                    case '电商':
                        this.secondBusinessTitle = '销售类目'
                        this.secondBusinessPlaceHolder = '如：生鲜、粮油'
                        break;
                    case '种植':
                        this.secondBusinessTitle = '种植作物'
                        this.secondBusinessPlaceHolder = '如：水稻、棉花'
                        break;
                    case '养殖':
                        this.secondBusinessTitle = '养殖种类'
                        this.secondBusinessPlaceHolder = '如：猪、肉牛'
                        break;
                    case '农产品加工':
                        this.secondBusinessTitle = '加工品类'
                        this.secondBusinessPlaceHolder = '如：粮食加工、柑橘加工'
                        break;
                    case '农资农机销售':
                        this.secondBusinessTitle = '销售品类'
                        this.secondBusinessPlaceHolder = '如：播种机、拖拉机、农资销售'
                        break;
                    case '农产品购销':
                        this.secondBusinessTitle = '产品类型'
                        this.secondBusinessPlaceHolder = '如：柑橘、蔬菜'
                        break;
                    case '农业服务':
                        this.secondBusinessTitle = '服务项目'
                        this.secondBusinessPlaceHolder = '如：收割、无人机植保'
                        break;
                    case '农业旅游农家乐':
                        this.secondBusinessTitle = '产业类型'
                        this.secondBusinessPlaceHolder = '如：玫瑰园、果园、农家乐餐饮'
                        break;
                    case '农业相关工程':
                        this.secondBusinessTitle = '工程内容'
                        this.secondBusinessPlaceHolder = '如：大棚、土壤改良、绿化工程'
                        break;
                    case '其他':
                        this.secondBusinessTitle = '经营项目'
                        this.secondBusinessPlaceHolder = '请填经营项目'
                        break;
                }
            },
            closeContent() {
                this.closeCallback.call()
            },
            calcTableHeight(){
                this.$nextTick(() => {
                    let height1=$(".content-box .content").height();
                    let height=height1-50-20-40-20;
                    this.scrollHeight = height;
                });
            },
        }
    }
</script>

<style>
  @import url(./assets/style/style.less);
/*.modify-flow-audit-content{*/
/*  background-color: rgb(220, 234, 235)!important;*/
/*  height: calc(100% - 15px);*/
/*  font-size: 14px;*/
/*  position: absolute;*/
/*  width: calc(100% - 20px);*/
/*  top: 10px;*/
/*  overflow-x: hidden;*/
/*  overflow-y: auto;*/
/*  box-sizing: border-box;*/
/*}*/
/*.close-btn{*/
/*  right: 20px;*/
/*  top: 10px;*/
/*  position: absolute;*/
/*  font-size: 27px;*/
/*  cursor: pointer;*/
/*}*/
/*.content{*/
/*  position: absolute;*/
/*  left: 0;*/
/*  top: 0;*/
/*  width: 100%;*/
/*  height: 100%;*/
/*}*/
</style>
